import { render } from "./field.vue?vue&type=template&id=f0b85f2c&ts=true"
import script from "./field.vue?vue&type=script&lang=ts"
export * from "./field.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__